import { connect, ConnectedProps } from 'react-redux';
import { ErrorGuard } from '@noths/polaris-client-next-components';
import { Dispatch } from 'redux';

import { ERROR_CATEGORY_NOT_FOUND, ERROR_PARTNER_NOT_FOUND } from 'src/constants/errors';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { refetchProducts } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';

export const mapStateToProps = ({ products, filter }: ReduxApplicationState) => ({
  error: products.error,
  shouldDisplayErrorMessage: !filter.filterModal.isModalOpen,
  notFoundErrorList: [ERROR_CATEGORY_NOT_FOUND, ERROR_PARTNER_NOT_FOUND],
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onRetry: () => (dispatch as AppThunkDispatch)(refetchProducts()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ListingsApiErrorGuardContainerProps = ConnectedProps<typeof connector>;

export const ListingsApiErrorGuardContainer = connector(ErrorGuard);
